

// 引入axios
import axios from 'axios'

// 引入qs
import qs from 'qs'
var ui = require('element-ui')


// 请求地址
// axios.defaults.baseURL="http://192.168.3.66:8088"
axios.defaults.baseURL="http://1.95.5.134:8088"

// axios.create({
//    data:data
// });
// // 环境的切换
// if (process.env.NODE_ENV == 'development') {    
//     axios.defaults.baseURL = 'https://www.baidu.com';} 
// else if (process.env.NODE_ENV == 'debug') {    
//     axios.defaults.baseURL = 'https://www.ceshi.com';
// } 
// else if (process.env.NODE_ENV == 'production') {    
//     axios.defaults.baseURL = 'https://www.production.com';
// }


// 请求超时设置
axios.defaults.timeout = 10000;

// 设置post的请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.post['Content-Type'] = 'application/json';

//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => { 
    console.log(config)    
    var shoptoken = window.localStorage.getItem("token");
    console.log(shoptoken,11111111111)
    // if(!config.headers['Content-Type']){
    //     config.headers = {
    //       'Content-Type':'application/json',
    //     };
    //   }
      if(shoptoken){
        config.headers.shoptoken = shoptoken
      }
        //在发送请求之前做某件事
        if(config.method  === 'post'){
            console.log(122)
            config.data = qs.parse(config.data);
        }
    return config;
},(error) =>{
    return Promise.reject(error);
});


//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) =>{
    // 对响应数据做些事
    if(!res.data.success){
        return Promise.resolve(res);
    }
    return res;
}, (error) => {
    console.log(error)
    if (error.response.status == 401) {
        ui.Message({
            message:'token过期，请重新登录！',
            type: 'warning'
          })
          window.localStorage.removeItem('name')
          window.localStorage.removeItem('shopId')
          window.localStorage.removeItem('token')
          window.localStorage.removeItem('state')
          setTimeout(function(){
            window.location.href = '/'
          },3000)
       
    }else if(error.response.status == 404){
        ui.Message({
            message:'未找到页面！',
            type: 'warning'
          })
    }else if(error.response.status == 500){
        ui.Message({
            message:'服务器异常！',
            type: 'warning'
          })
        //   setTimeout(function(){
        //     window.location.href = '/500'
        //   },3000)
    }
    return Promise.reject(error);
});

// 封装get方法和post方法
//返回一个Promise(发送post请求)
export function fetchPost(url, params) {
    console.log(url,params)
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);            
            })
            .catch((error) => {
                reject(error)
            })
    })
}
// fetchPost('params',{name:'1',value:'2'})
////返回一个Promise(发送get请求)
export function fetchGet(url, param) {
    return new Promise((resolve, reject) => {
        axios.get(url, param)
        .then(response => {
                if(response.status===200){
                    resolve(response);
                }else if(response.status===401){
                    location.href('/login')                    
                    window.localStorage.removeItem('token')
                }else if(response.status===404){
                    location.href('/404')
                }
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}




export default {
    fetchPost,
    fetchGet
}